// @ts-nocheck
import PropTypes from "prop-types";
import {BaseSpinner} from "@/components";
import GameCard from "../GameCard";

const containerCls = "w-full py-4 px-3 max-[600px]:bg-transparent";
const gridCls = "grid grid-cols-3 gap-2.5 min-[640px]:grid-cols-4 min-[900px]:grid-cols-6";

const List = ({selectedGameId, onGameSelect, games = [], loading = false, error = false}) => {
  if (loading) {
    return (
      <div
        className={containerCls}
        style={{textAlign: "center", padding: "2rem"}}
      >
        <BaseSpinner size="lg" />
      </div>
    );
  }
  if (error) {
    return (
      <div
        className={containerCls}
        style={{textAlign: "center", padding: "2rem"}}
      >
        <p style={{color: "var(--color-danger-text)", fontWeight: "bold"}}>
          Error loading lottery games. Please try again later.
        </p>
      </div>
    );
  }
  if (!games.length) {
    return (
      <div
        className={containerCls}
        style={{textAlign: "center", padding: "2rem"}}
      >
        <p>No games available for this category.</p>
      </div>
    );
  }
  return (
    <div className={containerCls}>
      <div className={gridCls}>
        {games.map(game => (
          <GameCard
            key={game.stringId || game.id}
            name={game.name}
            provider={game.provider}
            icon={game.icon}
            gameId={game.stringId}
            gameUuid={game.id}
            isFav={game.isFav}
            enable={game.enable}
            isSelected={selectedGameId === game.stringId}
            onGameSelect={onGameSelect}
          />
        ))}
      </div>
    </div>
  );
};

List.propTypes = {
  selectedGameId: PropTypes.string,
  onGameSelect: PropTypes.func.isRequired,
  games: PropTypes.array,
  loading: PropTypes.bool,
  error: PropTypes.bool,
};

export default List;
